define([
], function(declare) {
	return {
		GOOD_BIT:        8,
		BETTER_BIT:      4,
		BEST_BIT:        2,
		DEVELOPMENT_BIT: 1
	};
});
